
//NOTE: if we do not give an initial state, and when we call and try to display selectedProduct we can an empty redux array error!
const initialstateSelectedProduct = {     
    product: []
}

const selectedProductReducer = (state = initialstateSelectedProduct, action) => { 
//const selectedProductReducer = (state = {}, action) => {  //Error above will happen if we try to do this...
    switch(action.type){
        case 'SELECTED_PRODUCT':
            return {
                ...state,
                product: action.payload  //Sub category (level 2) in retruned object
            }
            default:
                return state;
    }
};
export default selectedProductReducer;